/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * <p>
 * Copyright © 2019 Pearson Education, Inc.
 * All Rights Reserved.
 * <p>
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 *
 * This is the data class for holding partner attributes.
 *
 * @author urahish
 * 12/03/2019
 *
 */

import React, {useState} from 'react';
import './warnings.css';
import Icon from "../../icon/Icon";
import Popup from "reactjs-popup";
import EventEmitter from "../../../../eventEmmiters/EventEmitter";

const Warning = () => {
    const [openWarningModel, setOpenWarningModel] = useState(false);
    const [warningModelData, setWarningModelData] = useState(null);

    EventEmitter.on('openWarningModel', event => setOpenWarningModel(event));
    EventEmitter.on('warningModelData', event => setWarningModelData(event));
    EventEmitter.emit('deleteFormData', false);

    const closeWarning = () => {
        setOpenWarningModel(false);
    };

    const deleteData = () => {
        EventEmitter.emit('deleteFormData', true);
        closeWarning();
    };

    const unlinkData = () => {
        EventEmitter.emit('unlinkFormData', true);
        closeWarning();
    };

    let model = null;
    if (warningModelData !== null)
        model =
            <Popup open={openWarningModel}>
                <div className="warning_modal">
                    <button className="pe-icon--btn static-close-title"
                            onClick={() => closeWarning()}
                            aria-label="Close warning">
                        <Icon name="remove-sm-24"/>
                    </button>
                    <div className="warning_header">
                        {warningModelData.type === 'unlink' ?
                            `Are you sure you want to unlink ${warningModelData.name}?` :
                            `Are you sure you want to delete ${warningModelData.name}?`
                        }
                    </div>
                    <div className="warning_content">
                        You can't undo this action!
                    </div>
                    <div className="warning_actions">
                        <input type="button" className="warning_actions_delete" value={warningModelData.type === 'unlink' ? 'Unlink' : 'Delete'}
                               onClick={warningModelData.type === 'unlink' ? unlinkData : deleteData}/>
                        <input type="button" className="warning_actions_cancel" value="Cancel"
                               onClick={() => closeWarning()} />
                    </div>
                </div>
            </Popup>

    return(
        <div>
            {model}
        </div>
    )
};

export default Warning;
